import { _ModalStore } from './modal.store';

export const openModalSelector = (state: _ModalStore) => state.openModal;
export const closeModalSelector = (state: _ModalStore) => state.closeModal;

export const closeAllModalsSelector = (state: _ModalStore) => state.closeAllModals;
